module.exports = __webpack_public_path__ + "img/xjb2.09e4b57d.jpg";